// extracted by mini-css-extract-plugin
export default {"expandableSectionWrapper":"ExpandableContentWrapper__expandableSectionWrapper-qVc4"};